<template>
    <v-card elevation="0">

        <v-overlay v-if="exporting">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>

        <input ref="uploaderImage"
               class="d-none"
               type="file"
               accept="image/*"
               @change="onFileChangedImage">

        <utils-explainers-pop-edit ref="utils-explainers-pop-edit"></utils-explainers-pop-edit>
        <v-card elevation="0" outlined width="100%">
            <v-card-actions class="ma-2 pa-0">
                <v-btn class="green white--text pr-5" elevation="0" @click="onPressCreate()"><v-icon class="mr-2">mdi-plus</v-icon>Create New</v-btn>
                <v-btn class="orange white--text pr-5" :loading="this.importing" elevation="0" @click="onPressAddImage()"><v-icon class="mr-2">mdi-image-plus</v-icon>Import Image</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="blue white--text pr-3" :loading="this.exporting" elevation="0" @click="onPressExport()"><v-icon class="mr-2">mdi-clipboard-check-outline</v-icon>Export</v-btn>
            </v-card-actions>
        </v-card>
        <v-card elevation="0" outlined width="100%" class="mt-2 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-card width="100%" elevation="0">
                    <v-card-title>
                        <v-text-field
                            outlined
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            clearable
                            hide-details
                            dense
                    ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            style="width: 100%;"
                            fixed-header
                            :items="getData"
                            v-model="selected"
                            :headers="headers"
                            :search="search"
                            :single-select="false"
                            item-key="key"
                            hide-default-footer
                            show-select
                            disable-pagination>

                        <template v-slot:item.key="{ item }">
                            <v-card-text class="blue--text">{{ item.key }}</v-card-text>
                        </template>

                        <template v-slot:item.addon.type.id="{ item }" >
                            <v-chip v-if="item.addon.type.id != 0" color="orange" dark>{{item.addon.type.name}}</v-chip>
                        </template>

                        <template v-slot:item.pages="{ item }">
                            {{ item.pages ? item.pages.length : 0 }}
                        </template>

                        <template v-slot:item.custom_title="{ item }" >
                            <v-chip v-if="item.custom_title && item.custom_title.length != 0" color="green" dark> true</v-chip>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                            color="green"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mr-1"
                                            @click="onPressEdit(item)">
                                        <v-icon size="22">mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>Edit explainer</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                           color="red"
                                           v-bind="attrs"
                                           v-on="on"
                                           class="mr-1"
                                           @click="onPressDelete(item)">
                                        <v-icon size="22">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete explainer</span>
                            </v-tooltip>
                        </template>

                    </v-data-table>
                </v-card>
            </v-card-actions>
        </v-card>
    </v-card>
</template>

<script>

import UtilsExplainersPopEdit from "@/modules/muiutils/views/explainers/utils-explainers-pop-edit";
import firebase from "firebase";
import JSZip from "jszip";
import {TimeUtils} from "@/common/TimeUtils";
import {deserialize, serialize} from "serializr";
import {ExplainerModel} from "@/modules/muiutils/models/explainers/ExplainerModel";
import {ExplainerPageModel} from "@/modules/muiutils/models/explainers/ExplainerPageModel";
import {ExplainerPageImageModel} from "@/modules/muiutils/models/explainers/ExplainerPageImageModel";

export default {
    name: "utils-explainers-page",
    components: {UtilsExplainersPopEdit},
    data: () => ({
        selected: [],
        exporting: false,
        importing: false,
        data: [],
        search: '',
        headers: [
            {text: 'Key', sortable: true, value: 'key', class: "white blue--text", color: "red"},
            {text: 'Uid', sortable: true, value: 'uid', class: "white blue--text", color: "red"},
            {text: 'Pages', sortable: true, value: 'pages', class: "white blue--text", color: "red"},
            {text: 'Custom Title', sortable: true, value: 'custom_title', class: "white blue--text", color: "red"},
            {text: 'Addon', sortable: true, value: 'addon.type.id', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'15%', align:'end'}
        ],
    }),
    methods:{

        getList(){
            var self = this;
            let db = firebase.database();
            db.ref("/explainers")
            .once("value")
            .then((snapshot) => {
                let data = Object.values(snapshot.val() || {});
                console.log(data);
                self.data = data.reduce((acc, v) => {
                    try {
                        acc.push(deserialize(ExplainerModel, v));
                    } catch (e) {
                        console.error("Failed to deserialize explainer:", e, v);
                    }
                    return acc;
                }, []);
                console.log(self.data);
                return Promise.resolve();
            }).catch((e) => {
                console.error("Failed to load explainers:", e);
            })
        },
        onPressAddImage(){
            window.addEventListener('focus', () => {
            }, { once: false })
            this.$refs.uploaderImage.click()
        },
        onFileChangedImage(e) {

            this.importing = true;

            let self = this;
            let name = e.target.files[0].name;

            firebase.storage()
                .ref("explainers/"+ name)
                .put(e.target.files[0])
                .then(() => {
                    self.importing = false;
                    self.$notify({title: 'Added', text: name, type: "succes"});
                }).catch((e) => {
                    self.importing = false;
                    self.$notify({title: 'Error', text: e, type: "error"});
            });
        },
        onPressExport(){

            let data = this.selected.map(v => serialize(ExplainerModel, v));

            if (data.length == 0){
                this.$notify({title: 'Export', text: "select one or more rows", type: "error"});
                return;
            }

            this.exporting = true;

            let needImage = [];
            let availableImageOnStorage = [];

            // let data = JSON.parse(JSON.stringify(this.getData));

            // let admisible = [
            //     "it_b_statue_druid",
            //     "it_b_statue_dwarf",
            //     "it_b_statue_elf",
            //     "it_b_statue_flower_elf",
            //     "it_fc_apiary",
            //     "it_fc_jam",
            //     "it_fc_windmill",
            //     "it_fc_loomit_fc_silk",
            //     "it_fc_bakery",
            //     "it_fc_pottery",
            //     "it_fc_icecream",
            //     "it_fc_workshop",
            //     "it_fc_craftshop",
            //     "it_fc_perfumery"
            // ];
            //
            // data = data.filter((d) => admisible.includes(d.key));

            for (let key in data){

                let pages = data[key].pages;
                for (let i in pages){

                    // pages[i].images = pages[i].images.filter((image) => image.id.length != 0);
                    let images = pages[i].images;

                    for (let j in images){
                        let name = images[j].id + ".png";
                        if (!needImage.includes(name)){
                            needImage.push(name);
                        }
                    }
                }
            }

            let jszip = new JSZip();
            let self = this;

            let total = 0;
            let storageRef = firebase.storage().ref("/explainers");
            storageRef.listAll().then(function(result) {

                console.log("total images: ", result.items.length)
                total = result.items.length;

                result.items.forEach(function(imageRef) {
                    let fileName = imageRef.fullPath;
                    fileName = fileName.replace("explainers/", "");

                    availableImageOnStorage.push(fileName);

                    if (!needImage.includes(fileName)){
                        console.log("skip, unused image: ", fileName);
                        total -= 1;
                        self.checkCompleteExport(data, jszip, total, availableImageOnStorage, needImage);
                        return;
                    }

                    imageRef.getDownloadURL().then(function(url) {

                        const xhr = new XMLHttpRequest();
                        xhr.responseType = 'blob';

                        xhr.onload = () => {

                            jszip.file(fileName, xhr.response);
                            total -= 1;
                            self.checkCompleteExport(data, jszip, total, availableImageOnStorage, needImage);

                        };
                        xhr.open('GET', url);
                        xhr.send();

                    }).catch(function(error) {
                        console.log(error)
                        self.exporting = false;
                        self.$notify({title: 'Export*', text: error, type: "error"});
                    })
                });

            }).catch(function(error) {
                console.log("error*:", error)
                self.exporting = false;
                self.$notify({title: 'Export**', text: error, type: "error"});
            });

        },
        checkCompleteExport(data, jszip, total, avaiableImageOnStorage, needImage){

            if (total > 0){ return;}

            let allertMessage = [];

            for (let i in needImage){
                let name =  needImage[i];
                if (!avaiableImageOnStorage.includes(name)) {
                    allertMessage.push(name)
                }
            }

            if (allertMessage.length != 0){
                this.$alert(allertMessage.join(","), "Missing images!", "error");
            }

            this.exporting = false;

            this.$notify({title: 'Exported', text: name, type: "succes"});

            jszip.file("explainers.json", JSON.stringify(data));

            let promise = jszip.generateAsync({type : "blob"})
            promise.then((blob) => {
                let FileSaver = require('file-saver');
                FileSaver.saveAs(blob, "explainers_"+TimeUtils.now()+".zip");
            })
            .catch((error) => {
                console.log("error:", error)
                this.$notify({title: 'Export', text: error, type: "error"});
            })


        },
        onPressCreate(){
            let data = new ExplainerModel([
                new ExplainerPageModel([
                        new ExplainerPageImageModel(), new ExplainerPageImageModel(), new ExplainerPageImageModel()
                    ]
                )
            ]);

            if(this.data.find((item) => item.key === data.key)){
                this.$alert("Dublicate Key !");
                return;
            }

            console.log("create:", data.uid, data);
            this.saveData(data);
            this.onPressEdit(data);
        },
        saveData(data){
            let d = serialize(ExplainerModel, data);
            let self = this;

            if(!data.key || data.key === ""){
                this.$alert("Empty Key !");
                return;
            }

            if(!data.pages || data.pages.length === 0){
                this.$alert("Empty pages !");
                return;
            }

            if(data.pages.some(page => !page.id && page.id === "")){
                this.$alert("Invalid id of any page !");
                return;
            }

            let db = firebase.database();
            console.log("save:", d.uid, d);
            return db.ref("/explainers/"+d.uid).set(d).then(() => {
                self.$notify({title: 'Saved', text: "", type: "succes"});
                return self.getList()
            }, (reason) => {
                console.error("add new explainer failed: " + reason);
                self.$notify({title: 'Saved', text: reason, type: "fail"});
            });
        },
        onPressDelete(item){
            this.$confirm("Are you sure?").then(() => {
                let self = this;
                let db = firebase.database();
                console.log("delete:", item.uid);
                return db.ref("/explainers/"+item.uid).set(null).then(() => {
                    self.$notify({title: 'Deleted', text: "", type: "succes"});
                    return self.getList()
                }, (reason) => {
                    console.error("delete explainer failed: " + reason);
                    self.$notify({title: 'Deleted', text: reason, type: "fail"});
                });
            }).catch(() => {})
        },
        onPressEdit(item){
            let self = this;
            let origin = JSON.stringify(serialize(ExplainerModel, item))
            this.$refs['utils-explainers-pop-edit'].show(item,function (model) {
                let edited = JSON.stringify(serialize(ExplainerModel, model))
                if (edited == origin){
                    console.log("no changes");
                    return;
                }
                self.saveData(model);
            })
        },
    },
    computed:{
        winsize() {
            return window.app.winsize;
        },
        getData(){
            return Object.values(this.data);
        }
    },
    created() {
        this.getList();
    }

}
</script>

<style scoped>
.scroll {
    overflow-y: scroll
}
</style>